import React from 'react'
import "../styles/footer.css"

export default function Footer() {
  return (
    <footer className='mt-3 py-3 text-center'>
      <div className='footer-links'>
        <a href="https://www.github.com/osas2211" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-github"></i></a>
            <a href="https://www.linkedin.com/in/osaretin-osariemen-frank-03047a1a6" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-linkedin"></i></a>
            <a href="https://www.instagram.com/franklophon" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-instagram"></i></a>
            <a href="https://twitter.com/Osaretinfrank3" target={"_blank"} rel="noreferrer" className='d-inline-block'><i class="fab fa-twitter-square"></i>
          </a>
      </div>
      <p className='my-0'>Designed and built by <span className='fw-bold'>Osariemen Osaretin Frank</span></p>
      <p className='my-0'>Powered by <span className='fw-bold' style={{color :"#2A9D8F"}}>React.js</span> and <span className='fw-bold' style={{color :"#E76F51"}}>Google Firebase</span></p>
      <p>&copy; All rights reserved 2022</p>
    </footer>
  )
}
